module.exports = __webpack_public_path__ + "static/mobx-diagram-616ed205dd060bad61290fb63402a1e0.jpg";